import type { Timestamp } from "firebase/firestore";

import { usableTimeZone } from "../event-experience/agenda-schedule";
import { APP_LOCALE } from "utils";

/** An opening or closing time on the event's clock, zone named. */
export function formatFormTime(value: Timestamp, timeZone?: string): string {
  return value.toDate().toLocaleString(APP_LOCALE, {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: usableTimeZone(timeZone),
    timeZoneName: "short",
  });
}
